// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"9f2eb123","67":"037bf82c","262":"a1bd34f0","710":"eaa37175","771":"64b8bc4c"}[chunkId] + ".chunk.js";
};